import { useMemo } from 'react';

import { getInfinityToolOptions } from 'src/data/infinity';

/**
 * Returns a memoized array of sorted and gropued generation tools
 */
export const useInfinityToolOptions = () => {
  return useMemo(() => getInfinityToolOptions(), []);
};
